export default __webpack_public_path__ + "static/favicon-212e33bca25f553fa156eda3de3d2d8d.ico";